import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../auth/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import MyDashboard from "../../modal/MyDashboard";
import Schedule from "../../modal/Schedule";
import MyNotes from "../../modal/MyNotes";
import RecentChat from "../../modal/RecentChat";
import menuItems from "./sidebar.json";
import * as MdIcons from "react-icons/md";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";
import * as GrIcons from "react-icons/gr";
import * as FaIcons6 from "react-icons/fa6";
import * as RiIcons from "react-icons/ri";
import * as TbIcons from "react-icons/tb";
import { Button, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { request } from "../../utils/api";
const icons = {
  ...MdIcons,
  ...FaIcons,
  ...AiIcons,
  ...BiIcons,
  ...GrIcons,
  ...FaIcons6,
  ...RiIcons,
  ...TbIcons,
};
const Sidebar = ({ isSidebarClose, isSidebarOpen }) => {
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();
  const { logout, user } = useContext(AuthContext);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [dropdownState, setDropdownState] = useState({
    sidebar: false,
  });

  const dropdownRefs = useRef({
    sidebar: null,
  });
  const handleOpen = (section) => {
    setDropdownState((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      let shouldClose = true;
      Object.values(dropdownRefs.current).forEach((ref) => {
        if (ref && ref.contains(event.target)) {
          shouldClose = false;
        }
      });
      if (shouldClose) {
        setDropdownState({
          sidebar: false,
        });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [openMenu, setOpenMenu] = useState(null);
  const handleToggle = (collapseId) => {
    setOpenMenu((prevOpenMenu) =>
      prevOpenMenu === collapseId ? null : collapseId,
    );
  };

  const [openMenu1, setOpenMenu1] = useState(false);
  const handleOpenMenu1 = () => setOpenMenu1(!openMenu1);

  const [openMenu2, setOpenMenu2] = useState(false);
  const handleOpenMenu2 = () => setOpenMenu2(!openMenu2);

  const [openMenu3, setOpenMenu3] = useState(false);
  const handleOpenMenu3 = () => setOpenMenu3(!openMenu3);

  const [auth, setAuth] = useState(false);
  const handleAuth = () => setAuth(!auth);

  const renderIcon = (iconSvg) => {
    return { __html: iconSvg };
  };

  const logoutUser = () => {
    logout();
    navigate("/auth-signin", { replace: true });
  };

  const userRole = JSON.parse(localStorage.getItem("yobas_role"));
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  const [sideItem, setSideItem] = useState([]);

  const filterSidebar = () => {
    if (userRole === "super_admin") {
      setSideItem(menuItems);
      return;
    }

    const filteredMenu = menuItems
      .filter((item) => item.Role.includes(userRole))
      .map((item) => {
        if (item.subMenu) {
          const filteredSubMenu = item.subMenu.filter((sub) =>
            permissions.includes(sub.permissionKey),
          );
          return { ...item, subMenu: filteredSubMenu };
        }
        return item;
      });

    const finalMenu = [
      filteredMenu[0],
      ...filteredMenu.slice(1).filter((item) => item.subMenu?.length > 0),
    ];

    setSideItem(finalMenu);
  };

  useEffect(() => {
    filterSidebar();
  }, [userRole]);

  const confirmDelete = async () => {
    if (userRole !== "super_admin") {
      toast.error("Only super admin can delete old labels");
      return;
    }

    try {
      setDeleteLoading(true);

      await request({
        url: "labels/cleanup",
        method: "DELETE",
      });

      toast.success("Old labels deleted successfully");
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete old labels");
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <>
    <ToastContainer/>
      <div
        className={`sidebar p-2 py-md-3 ${
          isSidebarClose ? "sidebar-mini" : isSidebarOpen ? "open" : ""
        }`}
      >
        <div className="container-fluid">
          <div className="title-text d-flex align-items-center mb-4 mt-1">
            <h4 className="sidebar-title mb-0 flex-grow-1">
              <span className="sm-txt">Yobas</span>
            </h4>
          </div>

          <div className="main-menu flex-grow-1">
            <ul className="menu-list">
              {sideItem.map((item, index) => {
                const isActive = item.subMenu?.some(
                  (subItem) => subItem.path === path,
                );
                const isOpen = openMenu === item.collapseId || isActive;
                const Icon = icons[item.icon];
                return (
                  <li key={index} className="collapsed">
                    <Link
                      className={
                        item.subMenu?.some((subItem) => subItem.path === path)
                          ? "m-link collapsed"
                          : "m-link"
                      }
                      data-bs-target={`#${item.collapseId}`}
                      aria-expanded={item.path ? item.path == path : isOpen}
                      onClick={() => handleToggle(item.collapseId)}
                      to={item.path}
                    >
                      {Icon && <Icon size={18} className="me-2" />}
                      <span className="ms-2">{item.title}</span>
                      {item.subMenu && (
                        <span className="arrow fa fa-angle-right ms-auto text-end"></span>
                      )}
                    </Link>
                    <ul
                      className={
                        isOpen ? "sub-menu collapse show" : "sub-menu collapse"
                      }
                      id={item.collapseId}
                    >
                      {item.subMenu?.map((subItem, subIndex) => {
                        return (
                          <li key={subIndex} className="collapsed">
                            <Link
                              className={
                                path === subItem.path
                                  ? "ms-link active"
                                  : "ms-link"
                              }
                              to={subItem.path}
                              data-bs-toggle={subItem.subMenu ? "collapse" : ""}
                              data-bs-target={
                                subItem.subMenu ? `#menu-level-${subIndex}` : ""
                              }
                            >
                              {subItem.title}
                              {subItem.subMenu && (
                                <span className="arrow fa fa-angle-right ms-auto text-end"></span>
                              )}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                );
              })}

              {/* {path == "/" && (
                <li className="collapsed curser">
                  <a
                    className={`m-link ${openMenu1 ? "" : "collapsed"}`}
                    onClick={handleOpenMenu1}
                    aria-expanded={openMenu1}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 3.5C6 3.10218 6.15804 2.72064 6.43934 2.43934C6.72064 2.15804 7.10218 2 7.5 2H8.5C8.89782 2 9.27936 2.15804 9.56066 2.43934C9.84196 2.72064 10 3.10218 10 3.5V4.5C10 4.89782 9.84196 5.27936 9.56066 5.56066C9.27936 5.84196 8.89782 6 8.5 6V7H14C14.1326 7 14.2598 7.05268 14.3536 7.14645C14.4473 7.24021 14.5 7.36739 14.5 7.5V8.5C14.5 8.63261 14.4473 8.75979 14.3536 8.85355C14.2598 8.94732 14.1326 9 14 9C13.8674 9 13.7402 8.94732 13.6464 8.85355C13.5527 8.75979 13.5 8.63261 13.5 8.5V8H8.5V8.5C8.5 8.63261 8.44732 8.75979 8.35355 8.85355C8.25979 8.94732 8.13261 9 8 9C7.86739 9 7.74021 8.94732 7.64645 8.85355C7.55268 8.75979 7.5 8.63261 7.5 8.5V8H2.5V8.5C2.5 8.63261 2.44732 8.75979 2.35355 8.85355C2.25979 8.94732 2.13261 9 2 9C1.86739 9 1.74021 8.94732 1.64645 8.85355C1.55268 8.75979 1.5 8.63261 1.5 8.5V7.5C1.5 7.36739 1.55268 7.24021 1.64645 7.14645C1.74021 7.05268 1.86739 7 2 7H7.5V6C7.10218 6 6.72064 5.84196 6.43934 5.56066C6.15804 5.27936 6 4.89782 6 4.5V3.5Z"
                      />
                      <path
                        className="fill-secondary"
                        d="M0.43934 10.4393C0.158035 10.7206 0 11.1022 0 11.5V12.5C0 12.8978 0.158035 13.2794 0.43934 13.5607C0.720644 13.842 1.10218 14 1.5 14H2.5C2.89782 14 3.27936 13.842 3.56066 13.5607C3.84196 13.2794 4 12.8978 4 12.5V11.5C4 11.1022 3.84196 10.7206 3.56066 10.4393C3.27936 10.158 2.89782 10 2.5 10H1.5C1.10218 10 0.720644 10.158 0.43934 10.4393Z"
                      />
                      <path
                        className="fill-secondary"
                        d="M6.43934 10.4393C6.15804 10.7206 6 11.1022 6 11.5V12.5C6 12.8978 6.15804 13.2794 6.43934 13.5607C6.72064 13.842 7.10218 14 7.5 14H8.5C8.89782 14 9.27936 13.842 9.56066 13.5607C9.84196 13.2794 10 12.8978 10 12.5V11.5C10 11.1022 9.84196 10.7206 9.56066 10.4393C9.27936 10.158 8.89782 10 8.5 10H7.5C7.10218 10 6.72064 10.158 6.43934 10.4393Z"
                      />
                      <path
                        className="fill-secondary"
                        d="M12.4393 10.4393C12.158 10.7206 12 11.1022 12 11.5V12.5C12 12.8978 12.158 13.2794 12.4393 13.5607C12.7206 13.842 13.1022 14 13.5 14H14.5C14.8978 14 15.2794 13.842 15.5607 13.5607C15.842 13.2794 16 12.8978 16 12.5V11.5C16 11.1022 15.842 10.7206 15.5607 10.4393C15.2794 10.158 14.8978 10 14.5 10H13.5C13.1022 10 12.7206 10.158 12.4393 10.4393Z"
                      />
                    </svg>
                    <span className="ms-2">Menu Level 0</span>
                    <span className="arrow fa fa-angle-right ms-auto text-end"></span>
                  </a>

                  <ul
                    className={`sub-menu collapse ${
                      openMenu1 ? "show" : false
                    }`}
                    id="menu-level0"
                  >
                    <li className="collapsed">
                      <a
                        className={`m-link ${openMenu2 ? "" : "collapsed"}`}
                        onClick={handleOpenMenu2}
                        aria-expanded={openMenu2}
                      >
                        <span>Menu Level 1</span>{" "}
                        <span className="arrow fa fa-angle-right ms-auto text-end"></span>
                      </a>
                      <ul
                        className={`sub-menu collapse ${
                          openMenu2 ? "show" : false
                        }`}
                        id="menu-level1"
                      >
                        <li className="collapsed">
                          <a
                            className={`m-link ${openMenu3 ? "" : "collapsed"}`}
                            onClick={handleOpenMenu3}
                            aria-expanded={openMenu3}
                          >
                            <span>Menu Level 2</span>{" "}
                            <span className="arrow fa fa-angle-right ms-auto text-end"></span>
                          </a>
                          <ul
                            className={`sub-menu collapse ${
                              openMenu3 ? "show" : false
                            }`}
                            id="menu-level2"
                          >
                            <li>
                              <a className="ms-link" href="#">
                                Menu Level 3
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a className="ms-link" href="#">
                            Menu Level 2
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a className="ms-link" href="#">
                        Menu Level 1
                      </a>
                    </li>
                  </ul>
                </li>
              )} */}
            </ul>
          </div>

          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete old labels?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowDeleteModal(false)}
                disabled={deleteLoading}
              >
                Cancel
              </Button>

              <Button
                variant="danger"
                onClick={confirmDelete}
                disabled={deleteLoading}
              >
                {deleteLoading ? "Deleting..." : "Delete"}
              </Button>
            </Modal.Footer>
          </Modal>

            {userRole === "super_admin" && (
              <li className="nav-item flex-fill p-2">
                <button
                  className="btn btn-danger w-100"
                  onClick={() => setShowDeleteModal(true)}
                >
                  Delete Old Labels
                </button>
              </li>
            )}
          <ul className="menu-list nav navbar-nav flex-row text-center menu-footer-link">
            <li className="nav-item flex-fill p-2">
              <Link
                className="d-inline-block w-100 color-400"
                to="#"
                onClick={logoutUser}
                title="sign-out"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M7.5 1v7h1V1h-1z" />
                  <path
                    className="fill-secondary"
                    d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"
                  />
                </svg>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="modal fade" id="CreateNew" tabIndex="-1">
        <div className="modal-dialog modal-dialog-vertical modal-dialog-scrollable">
          <MyDashboard />
        </div>
      </div>

      <div className="modal fade" id="ScheduleModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-vertical modal-dialog-scrollable">
          <Schedule />
        </div>
      </div>

      <div className="modal fade" id="MynotesModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-vertical modal-dialog-scrollable">
          <MyNotes />
        </div>
      </div>
      <div className="modal fade" id="RecentChat" tabIndex="-1">
        <div className="modal-dialog modal-dialog-vertical modal-dialog-scrollable">
          <RecentChat />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
